import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquarePlaceholderDashed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquarePlaceholderDashed"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H6.45V4.5H4.5V6.5H3V3ZM9.5 3H14.5V4.5H9.5V3ZM17.5 3H21V6.5H19.5V4.5H17.5V3ZM4.5 9.5V14.5H3V9.5H4.5ZM21 9.5V14.5H19.5V9.5H21ZM4.5 17.5V19.5H6.45V21H3V17.5H4.5ZM21 17.5V21H17.5V19.5H19.5V17.5H21ZM9.5 19.5H14.5V21H9.5V19.5Z" fill="currentColor"/><Path d="M6 6H18V18H6V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquarePlaceholderDashed;
